import { Dispatch, type SetStateAction } from 'react';
import { datadogLogs } from '@datadog/browser-logs';

export const showApplePay = (
  flags: Record<string, unknown>,
  setShowApplePayOption: Dispatch<SetStateAction<boolean>>,
  showApplePayOption: boolean,
) => {
  if (flags && !flags.enableApplePaySocialEcomm) {
    setShowApplePayOption(false);
    return false;
  }
  if (window.ApplePaySession && !showApplePayOption) setShowApplePayOption(true);
  return !!window.ApplePaySession;
};

export const loadApplePay = (
  applePayAvailable: unknown,
  setApplePayLoaded: Dispatch<SetStateAction<boolean>>,
) => {
  if (
    applePayAvailable &&
    window.ApplePaySession &&
    window.ApplePaySession.canMakePaymentsWithActiveCard
  ) {
    const merchantIdentifierRoot = document.location.hostname.split('.')[0];
    const merchantIdentifier = `merchant.com.${merchantIdentifierRoot}`;
    const promise = window.ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
    if (promise && typeof promise.then === 'function') {
      promise
        .then((canMakePayments: boolean) => {
          if (canMakePayments) {
            setApplePayLoaded(true);
          }
          datadogLogs.logger.info('Apple Pay loaded');
        })
        .catch((err: unknown) => {
          datadogLogs.logger.error('Apple Pay error:', {}, err as Error);
        });
    } else {
      const err = new Error(
        'Apple Pay canMakePaymentsWithActiveCard function is not returning a promise',
      );
      datadogLogs.logger.error('Apple Pay error:', {}, err);
    }
  }
};
